import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker, unregister as unregisterServiceWorker } from './serviceWorkerRegistration';
import { OFFLINE_FIELD_MODE } from './config/features';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Copia local de CONEM para abrirlo sin señal (solo en producción). Apagada: se desinstala la
// que haya quedado en el navegador y se limpia la sesión compartida que guardaba la v2.5.0 previa.
if (OFFLINE_FIELD_MODE) {
  registerServiceWorker();
} else {
  unregisterServiceWorker();
  try {
    ['authToken', 'userInfo', 'permissionsCache'].forEach((key) => localStorage.removeItem(key));
  } catch { /* almacenamiento bloqueado */ }
}
